import { render, staticRenderFns } from "./login-comp.vue?vue&type=template&id=57f03e1c&scoped=true&"
import script from "./login-comp.vue?vue&type=script&lang=js&"
export * from "./login-comp.vue?vue&type=script&lang=js&"
import style0 from "./login-comp.vue?vue&type=style&index=0&id=57f03e1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f03e1c",
  null
  
)

export default component.exports